// Idempotentlik kaliti — "Sotib olish" tugmasini ikki marta bosish ikki
// paket bermasligi uchun (vazifa hujjati, Paketlar bo'limi).
//
// Tugma `isPending` paytida o'chiriladi (ikkinchi UI qatlami), lekin bu
// yetarli emas: tarmoq sekin bo'lsa, birinchi so'rov hali ketayotganda
// foydalanuvchi ikkinchi marta bosib ulguradi, yoki brauzer avtomatik qayta
// urinishi mumkin. `Idempotency-Key` haqiqiy himoya — server BIR XIL kalit
// bilan kelgan ikkinchi so'rovni ikkinchi xarid deb hisoblamaydi.

/**
 * Yangi kalit — HAR BIR yangi xarid NIYATI uchun BITTA marta chaqiriladi
 * (masalan modal ochilganda), keyin shu bitta qiymat mutatsiya davomida
 * (va uning qayta urinishlarida) ishlatib turiladi.
 */
export function newIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }
  // Zaxira — juda eski brauzer uchun (randomUUID keng qo'llab-quvvatlanadi,
  // lekin himoyasiz qolmaslik uchun)
  return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`
}
